"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValidationResult = /** @class */ (function () {
    function ValidationResult() {
        this.valid = true;
        this.errors = [];
    }
    return ValidationResult;
}());
exports.default = ValidationResult;
//# sourceMappingURL=ValidationResult.js.map